import './_copy-select.scss';

import { arrayOf, bool, func, number, object, shape, string } from 'prop-types';
import React from 'react';
import { GoClippy } from 'react-icons/go';
import {
  Button,
  ListGroup,
  ListGroupItem,
  Popover,
  PopoverBody,
  PopoverHeader,
} from 'reactstrap';

import FEATURE_FLAGS, { useSafeFlag } from '../../utils/flags';

class CopySelectImpl extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { isOpen: false };

    this.handleToggle = this.handleToggle.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  handleToggle() {
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }));
  }

  handleClick(event) {
    const { onClick, options, value } = this.props;
    const { name } = event.target;

    // Reactstrap toggles the popover with a timeout.
    // Therfore we need to defer hiding the popover so it is not hidden
    // immediately and then reopened through Reactstrap.
    setTimeout(() => this.setState({ isOpen: false }));

    const targetIds =
      name === 'all'
        ? options.map(option => option.target)
        : [Number.parseInt(name, 10)];

    onClick(value, targetIds);
  }

  render() {
    const { className, id, options, title, isDisabled } = this.props;
    const { isOpen } = this.state;

    return (
      <>
        <Button
          id={id}
          className={className}
          type="button"
          outline
          disabled={isDisabled}
        >
          <GoClippy className="va-n1" />
        </Button>

        <Popover
          target={id}
          isOpen={isOpen}
          toggle={this.handleToggle}
          trigger="legacy"
          placement="right"
          boundariesElement="window"
          className="c-copy-select__popover"
        >
          <PopoverHeader>Copy {title} to:</PopoverHeader>
          <PopoverBody>
            <ListGroup>
              <ListGroupItem
                tag="button"
                action
                onClick={this.handleClick}
                className={`${id}-all`}
                name="all"
              >
                All
              </ListGroupItem>
              {options.map(({ label, target }) => (
                <ListGroupItem
                  key={`${id}-${target}`}
                  tag="button"
                  action
                  onClick={this.handleClick}
                  name={target.toString(10)}
                >
                  {label}
                </ListGroupItem>
              ))}
            </ListGroup>
          </PopoverBody>
        </Popover>
      </>
    );
  }
}

CopySelectImpl.propTypes = {
  className: string,
  id: string.isRequired,
  title: string.isRequired,
  value: object.isRequired, // eslint-disable-line react/forbid-prop-types
  onClick: func.isRequired,
  options: arrayOf(
    shape({ label: string.isRequired, target: number.isRequired }),
  ).isRequired,
  isDisabled: bool,
};

CopySelectImpl.defaultProps = {
  className: 'px-2 py-1',
  isDisabled: false,
};

function CopySelect(props) {
  const isDraftCampaignEnabled = useSafeFlag(FEATURE_FLAGS.DRAFT_CAMPAIGN);
  const { disabled, isDisabled, ...restProps } = props;
  const finalDisabled = isDraftCampaignEnabled ? disabled : isDisabled;

  return <CopySelectImpl isDisabled={finalDisabled} {...restProps} />;
}

CopySelect.propTypes = {
  disabled: bool,
  isDisabled: bool,
};

CopySelect.defaultProps = {
  disabled: false,
  isDisabled: false,
};

// Export the base component for testing purposes only
export { CopySelectImpl };

export default CopySelect;
